import { createSelector } from '@reduxjs/toolkit';

import { chatListSelector } from './chatListSelector';

export const selectChatListStatus = createSelector(chatListSelector, chatList => chatList.status);
